
module.exports = function(i, str) {
    return i+str.split("\n")       // get all lines
              .join("\n"+i)      // join all lines with an indent
}


//////////////////
// WEBPACK FOOTER
// ./indent.js
// module id = 25
// module chunks = 0